import { create } from 'zustand'
import { persist } from 'zustand/middleware'

// Pack List Builder selection — lives outside the page component so navigating
// away and back doesn't lose Gina's location / event week / discipline pick.
type EventsState = {
  packLocationId?: number
  packEventId?: number
  // Additional event weeks packed together with the primary one.
  packExtraIds: number[]
  packDiscipline: string
  // Pack List table column widths (px) the user has dragged, keyed by column
  // key — absent keys fall back to the column's default width.
  packColWidths: Record<string, number>
  setPackSelection: (
    patch: Partial<Pick<EventsState, 'packLocationId' | 'packEventId' | 'packExtraIds' | 'packDiscipline'>>
  ) => void
  setPackColWidth: (key: string, width: number) => void
  resetPackColWidth: (key: string) => void
}

export const useEventsStore = create<EventsState>()(
  persist(
    (set) => ({
      packLocationId: undefined,
      packEventId: undefined,
      packExtraIds: [],
      packDiscipline: '',
      packColWidths: {},
      setPackSelection: (patch) => set(patch),
      setPackColWidth: (key, width) =>
        set((s) => ({ packColWidths: { ...s.packColWidths, [key]: width } })),
      resetPackColWidth: (key) =>
        set((s) => {
          const next = { ...s.packColWidths }
          delete next[key]
          return { packColWidths: next }
        }),
    }),
    { name: 'events-packlist-selection' }
  )
)
